module.exports = __webpack_public_path__ + "img/Frame 1124two.22a51db2.png";